import { render, staticRenderFns } from "./hiddenGovern.vue?vue&type=template&id=45b3b4a9&scoped=true"
import script from "./hiddenGovern.vue?vue&type=script&lang=js"
export * from "./hiddenGovern.vue?vue&type=script&lang=js"
import style0 from "./hiddenGovern.vue?vue&type=style&index=0&id=45b3b4a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b3b4a9",
  null
  
)

export default component.exports